import React from 'react';

import {
  CreateUpdateProjectWithTeamDto,
  GetProjectDto,
} from '../../../common/pokCore/autogenerated/pokApiClient/models';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { isPendingDateChangeApplication } from '../../../common/pokCore/contexts/ProjectContext';
import momencik from '../../../common/momencik';

interface PendingProjectApplicationAlertProps {
  project: CreateUpdateProjectWithTeamDto | GetProjectDto;
}

export const PendingProjectApplicationAlert: React.FC<
  PendingProjectApplicationAlertProps
> = props => {
  const { t, tk } = useTranslation('projectLng');
  const message = [];
  if (props.project.cancelVerification) {
    message.push(
      t(tk.projects.cancelApplicationSubmitted, {
        project: t(tk.prLang.genitiveProject),
      }),
    );
  }
  if (isPendingDateChangeApplication(props.project)) {
    message.push(
      t(tk.projects.dateChangeApplicationSubmitted, {
        project: t(tk.prLang.genitiveProject),
        startDate: props.project.newStartDate
          ? momencik(props.project.newStartDate, 'L')
          : momencik(props.project.startDate, 'L'),
        endDate: props.project.newEndDate
          ? momencik(props.project.newEndDate, 'L')
          : momencik(props.project.endDate, 'L'),
      }),
    );
  }
  if (message.length === 0) {
    return null;
  }

  return <ValidationAlert show={true} errors={message} className="m-3" />;
};
